import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../../Store/user/userSlice';
import styles from '../../styles/Profile.module.scss';

const tabs = [
  { to: '/profile', label: 'Редагування профілю', end: true },
  { to: '/favorites', label: 'Улюблені товари' },
  { to: '/orders', label: 'Список замовлень' },
];

const ProfileNavigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(setCurrentUser(null));
    navigate('/');
  };

  return (
    <nav className={styles.profileNavigation} aria-label="Навігація особистого кабінету">
      {tabs.map(({ to, label, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink
          }
        >
          {label}
        </NavLink>
      ))}
      <button
        type="button"
        className={styles.logoutButton}
        onClick={handleLogout}
      >
        Вийти
      </button>
    </nav>
  );
};

export default ProfileNavigation;
